module.exports = __webpack_public_path__ + "static/img/5bac.fd8a5cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/5bac.jpg
// module id = 6bpY
// module chunks = 1